import { CompanyWorker } from 'api/worker'
import { Avatar, Flex, Box, Text, Button } from '@workwhile/ui'
import { useShiftEditor } from '../../useShiftEditor'
import { toTitleCase } from 'lib/legacy_util'
import { SelectedWorkerStatus } from 'components/WorkersSelector/SelectedWorkerStatus'
import { useHypotheticalShifts } from 'hooks/useHypotheticalShifts'
import { EditorMode } from 'pages/ShiftEditorPage/ShiftEditorProvider'

interface Props {
  data: CompanyWorker
  onRemove?: () => void
}

export function RSWCard(props: Props) {
  const { data } = props
  const { editData, editorMode } = useShiftEditor()
  const workerName = toTitleCase(data.name)
  const hypotheticalShifts = useHypotheticalShifts()

  return (
    <Flex
      alignItems={['flex-start', 'center']}
      width={1}
      my={3}
      flexWrap={'wrap'}
    >
      <Avatar
        size={'medium'}
        user={{
          userId: data.id.toString(),
          name: data.name,
          photoUrl: data.profilePicUrl,
        }}
      />
      <Flex
        flex={1}
        flexDirection={['column', 'row']}
        alignItems={['flex-start', 'center']}
      >
        <Box ml={3} flex={1}>
          <Text>{workerName}</Text>
          {editorMode !== EditorMode.PastShift ? (
            <Box display="inline-flex">
              <SelectedWorkerStatus
                worker={data}
                hypotheticalShifts={hypotheticalShifts}
                existingShift={editData}
              />
            </Box>
          ) : null}
        </Box>
        <Button kind={'medium'} onClick={props.onRemove} mt={[2, 0]}>
          Remove
        </Button>
      </Flex>
    </Flex>
  )
}
